/**
 * Copyright © Veeam Software Group GmbH.
 */

export function isDate(value: any): boolean {
    return value instanceof Date && !isNaN(+value);
}
